<template>
  <section class="w-full p-8 mt-4">
    <div class="flex flex-col items-center">
      <h2 class="dark:text-zinc-500 text-3xl mb-5">The "{{ featureName }}" option is not yet supported in the Zight Beta.</h2>
      <span class="dark:text-zinc-500 mb-5">To access the "{{ featureName }}” feature, please use the Classic layout. </span>
      <Button class="mb-2" :href="`/${id}?viewer=classic`" target="__blank" data-testid="beta-enter-classic-button"
        >Switch to Classic Zight for a moment</Button
      >
      <Button href="https://w4x62lq5h9m.typeform.com/to/HFgrVA74" target="__blank" type="link" data-testid="beta-send-feedback-button">Send feedback</Button>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { Button } from '@/storybook/button';
import { storeToRefs } from 'pinia';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

defineProps({
  featureName: {
    type: String,
    required: true,
  },
});

const { id } = storeToRefs(useViewerItemStore());
</script>
